import { PocIcon, PocTag, PocTooltip } from 'commons/components/components-wrapper';
import { useAsyncTooltipMount } from 'commons/hooks';
import { PropsWithChildren } from 'react';

export type AlarmTagSeverity = 'warning' | 'error';

export interface AlarmTagComponentProps extends PropsWithChildren {
    severity: AlarmTagSeverity;
    size?: number;
    mountDelayMs?: number;
}

export const AlarmTagComponent: React.FC<AlarmTagComponentProps> = ({ severity, size, mountDelayMs = 0, children }) => {
    const { tooltipAnchorId, isMountedTooltip, isVisibleTooltip, onMouseEnter, onMouseLeave } = useAsyncTooltipMount({
        mountDelayMs,
    });
    return (
        <div data-testid={`device-${severity}-alarm`}>
            <PocTag
                status={severity === 'error' ? 'alarm' : 'warning'}
                id={tooltipAnchorId}
                style={{ minWidth: '24px' }}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <PocIcon slot="prefix" name="alarm" />
                {size ?? undefined}
            </PocTag>

            {isMountedTooltip && (
                <PocTooltip anchor={tooltipAnchorId} placement="top" disableTriggers visible={isVisibleTooltip}>
                    {children}
                </PocTooltip>
            )}
        </div>
    );
};
